<template>
  <div class="equipmentMaintain mainPageBg"
    v-loading="$store.state.user.loadingState">
    <div class="sheetsContent commonOrderContent">
      <div class="formBox">
        <el-form :inline="true"
          :model="formInline"
          class="demo-form-inline">
          <el-form-item label="设备区域">
            <el-cascader v-model="formInline.area"
              :options="areaList"
              :show-all-levels="false"
              :props="{ checkStrictly: true,label:'name',value:'id',emitPath: false }"
              clearable></el-cascader>
          </el-form-item>
          <el-form-item label="搜索">
            <el-input v-model="formInline.searchTxt"
              placeholder="请输入内容"
              clearable>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary"
              @click="handleSizeChange(10)">查询</el-button>
            <el-button type="warning"
              v-if="judgeAuthority('houqinguanli:baoyangguanli:equipmentMaintain:edit')"
              icon="el-icon-plus"
              @click="clickItem = {pointType:'PERSONAL'};editCom = true">新增保养设备</el-button>
            <el-button type="primary" plain
              v-if="judgeAuthority('houqinguanli:baoyangguanli:equipmentMaintain:export')"
              @click="exportExcel"><i class="el-icon-download el-icon--left"></i>EXCEL</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="tabCardBox">
        <div class="orderCardItem">
          <el-table :data="tableData"
            stripe
            border
            style="width: 100%"
            class="tabWrap"
            height="93%"
            :cell-style="cellStyle"
            @cell-click="cellClick"
            :header-cell-style="{
            'background-color': '#F7F7F7',
            }">
            <el-table-column v-for="(v, i) in tabHead"
              :key="i"
              :prop="v.prop"
              :label="v.label"
              :show-overflow-tooltip="true"
              align="center">
              <template slot-scope="scope">
                <span v-if="scope.row[v.prop] && v.prop == 'user'">
                  <el-link type="primary"
                    v-for="(item,index) in scope.row.maintenancePersonnel"
                    :key="item.id"
                    @click="toUserPage(item)">{{index == scope.row.maintenancePersonnel?.length -1?item.name:`${item.name}、`}}</el-link>
                </span>
                <span v-else>{{ scope.row[v.prop] }}</span>
              </template>
            </el-table-column>
            <el-table-column fixed="right"
              align="center"
              label="操作"
              width="150"
              v-if="judgeAuthority('houqinguanli:baoyangguanli:equipmentMaintain:edit')">
              <template slot-scope="scope">
                <el-button @click="handleClick(scope.row)"
                  type="text"
                  size="mini">立即保养</el-button>
                <el-button type="text"
                  size="mini"
                  @click="editBtn(scope.row)">编辑</el-button>
                <el-button type="text"
                  size="mini"
                  v-if="scope.row.pointType =='PERSONAL'"
                  @click="deleteBtn(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 30, 50]"
            :page-size="page.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="page.total"
            style="margin-top: 10px; text-align: right">
          </el-pagination>
        </div>
      </div>

    </div>

    <AddEditEquipment v-if="editCom"
      :clickItem="clickItem" />
    <CarryOut v-if="carryOutCom"
      :clickItem="clickItem" />

  </div>
</template>

<script>
import api from "@/api";
import { dateFtt, judgeAuthority, exportExcelFun } from "@/assets/js/utils";
import AddEditEquipment from "@/components/houqinguanli/baoyangguanli/AddEditEquipment.vue";
import CarryOut from "@/components/houqinguanli/baoyangguanli/CarryOut.vue";
import exportFile from "@/assets/js/xlsxFile";
import XLSX from "xlsx";
export default {
  components: {
    AddEditEquipment,
    CarryOut,
  },
  data() {
    return {
      editCom: false,
      carryOutCom: false,
      formInline: {
        searchTxt: "",
        area: null,
      },
      areaList: [],
      tableData: [],
      tabHead: [
        { label: "设备名称", prop: "name" },
        { label: "设备地址", prop: "location" },
        { label: "建议保养时间", prop: "recommendationTime" },
        { label: "最近保养时间", prop: "lastTime" },
        { label: "保养人员", prop: "user" },
        { label: "投运时间", prop: "time" },
        { label: "保养周期", prop: "cycle" },
        { label: "本年度保养次数", prop: "annualMaintenanceFrequency" },
        { label: "保养内容", prop: "maintenanceContent" },
      ],
      currentPage: 1,
      page: {
        total: null,
        size: 10,
      },
      clickItem: {},
    };
  },
  methods: {
    judgeAuthority,
    toUserPage(data) {
      this.$router.push({
        name: "authority",
        params: { userId: data.id },
      });
    },
    handleClick(row) {
      this.clickItem = row;
      this.carryOutCom = true;
    },
    deleteBtn(row) {
      this.$confirm("此操作将永久删除该设备, 是否确认?", "删除设备", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let res = await api.patrolPointDelete({}, row.id);
          if (res && res.data.code == 200) {
            this.$message.success("删除成功!");
            this.$store.commit("SET_LOADING", true);
            setTimeout(() => {
              this.getList();
            }, 1000);
          }
        })
        .catch(() => {});
    },
    editBtn(row) {
      this.clickItem = row;
      this.editCom = true;
    },
    cellStyle(row) {
      if (row.column.label === "设备名称" && row.row.pointType == "SYSTEM") {
        return "color:#28CCCB;cursor: pointer;";
      }
    },
    cellClick(row, column) {
      if (column.label == "设备名称" && row.pointType == "SYSTEM") {
        this.$router.push({
          path: "/equipmentmanagement",
          query: { equipmentName: row.name },
        });
      }
    },

    handleSizeChange(val) {
      this.page.size = val;
      this.currentPage = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
    getAsseList() {
      let treeAllData = JSON.parse(
        window.sessionStorage.getItem("assetsAllData")
      );
      this.areaList = [treeAllData.区域位置];
    },
    async getList() {
      this.tableData = [];
      this.$store.commit("SET_LOADING", true);
      let res = await api.patrolPointPageList({
        pageSize: this.page.size,
        page: this.currentPage - 1,
        name: this.formInline.searchTxt,
        assetId: this.formInline.area,
        sourceType: "MAINTENANCE",
      });
      if (res && res.data.code == 200) {
        this.$store.commit("SET_LOADING", false);
        this.tableData = res.data.data.data;
        this.tableData.map((v) => {
          v.recommendationTime = v.recommendedMaintenanceTime
            ? dateFtt("yyyy-MM-dd", new Date(v.recommendedMaintenanceTime))
            : "-";
          v.lastTime = v.latestMaintenanceTime
            ? dateFtt("yyyy-MM-dd", new Date(v.latestMaintenanceTime))
            : "-";
          v.user = v.maintenancePersonnel
            ?.map((item) => {
              return item.name;
            })
            .join(",");
          v.cycle = v.maintenanceIntervals
            ? `${v.maintenanceIntervals}天/次`
            : "-";
          v.time = v.operationTime
            ? dateFtt("yyyy-MM-dd", new Date(v.operationTime))
            : "-";
        });
        this.page.total = res.data.data.totalElements;
      }
    },
    exportExcel() {
      exportFile.xlsxFile(XLSX, "保养设备信息", {
        excel: exportExcelFun(this.tabHead, this.tableData),
      });
    },
  },
  created() {
    this.getAsseList();
    this.getList();
  },
};
</script>

<style lang="scss" scoped>
.equipmentMaintain {
  @include setFlexCenter;
  .sheetsContent {
    width: 98%;
    height: 96%;
    ::v-deep .el-input--suffix .el-input__inner {
      vertical-align: bottom !important;
    }
  }
}
</style>